export default __webpack_public_path__ + "static/media/airbnb.c5bf6d4e.png";